/* DA native features — bundle builder (replaces EasyFlow), size guide, labels in the shopper's language, English digits. */
(function () {
  'use strict';
  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  // name: [Arabic, English, swatch]
  var COL = {
    black: ['أسود', 'Black', '#111111'], balck: ['أسود', 'Black', '#111111'],
    white: ['أبيض', 'White', '#ffffff'],
    offwhite: ['أوف وايت', 'Off-white', '#f3ede2'], 'off white': ['أوف وايت', 'Off-white', '#f3ede2'], 'off-white': ['أوف وايت', 'Off-white', '#f3ede2'],
    navy: ['كحلي', 'Navy', '#1f2a48'], blue: ['كحلي', 'Navy', '#1f2a48'], 'dark blue': ['كحلي', 'Navy', '#1f2a48'],
    gray: ['رمادي', 'Grey', '#8c8f94'], grey: ['رمادي', 'Grey', '#8c8f94'],
    beige: ['بيج', 'Beige', '#d8c3a0'], bege: ['بيج', 'Beige', '#d8c3a0']
  };
  var OPT = { color: 'اللون', colour: 'اللون', size: 'المقاس' };
  var REG = {};

  function L(a, e) { return AR ? a : e; }
  function norm(s) { s = String(s == null ? '' : s).trim().toUpperCase(); return s === '2XL' ? 'XXL' : s; }
  function ck(n) { return String(n || '').trim().toLowerCase(); }
  function colAr(n) { return COL[ck(n)] ? COL[ck(n)][0] : n; }
  function colLabel(n) { return COL[ck(n)] ? (AR ? COL[ck(n)][0] : COL[ck(n)][1]) : n; }
  function colHex(n, fallback) { return COL[ck(n)] ? COL[ck(n)][2] : (fallback || '#cccccc'); }
  function pcs(n) { return AR ? (n == 2 ? 'قطعتين' : n + (n > 10 ? ' قطعة' : ' قطع')) : n + ' pcs'; }
  function E(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }


  /* 0. English digits everywhere: convert Arabic-Indic and Persian digits typed into content */
  var DIG = /[٠-٩۰-۹]/;
  var DIGG = /[٠-٩۰-۹]/g;
  function toEn(t) { return t.replace(DIGG, function (d) { var c = d.charCodeAt(0); return String(c >= 0x06F0 ? c - 0x06F0 : c - 0x0660); }); }
  // currency label in the shopper's language: "د.ك" on the Arabic site, "KD" on the English site
  // (prices are written like "KD20.000", so KD may touch the digits)
  var CUR = AR ? /\bKWD\b|\bKD(?![A-Za-z])/g : /د\.ك\.?/g;
  var CUR1 = AR ? /\bKWD\b|\bKD(?![A-Za-z])/ : /د\.ك/;
  function fix(t) {
    t = toEn(t);
    if (CUR1.test(t)) {
      t = t.replace(CUR, AR ? 'د.ك' : 'KD').replace(/KWD KD/, 'KWD').replace(/د\.ك د\.ك/, 'د.ك');
      if (AR) t = t.replace(/د\.ك(?=\d)/g, 'د.ك ');
    }
    return t;
  }
  function digits(root) {
    if (!root || !root.body) return;
    var w = document.createTreeWalker(root.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!DIG.test(n.nodeValue) && !CUR1.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName) || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (x) { var v = fix(x.nodeValue); if (v !== x.nodeValue) x.nodeValue = v; });
    root.querySelectorAll('img[alt], [aria-label], input[placeholder]').forEach(function (el) {
      ['alt', 'aria-label', 'placeholder'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (v && DIG.test(v)) el.setAttribute(a, toEn(v));
      });
    });
    if (DIG.test(document.title)) document.title = toEn(document.title);
  }

  /* 1. Arabic labels for option names and colour values that come from product data */
  // option names typed in either language, e.g. "القياس (كود 32)", "Size (Code 1/10)", "Color (All)"
  var RX_NUM = /(?:code|كود|الكود)\s*:?\s*([0-9٠-٩\/\-]+)/i;
  function optLabel(t) {
    var c = (t.match(RX_NUM) || [])[1];
    c = c ? toEn(c) : '';
    if (/^\s*\d*\s*(colou?r|اللون|لون)/i.test(t) || /\(\s*colou?r\s*\)/i.test(t)) {
      return c ? L('اللون (كود ' + c + ')', 'Colour (Code ' + c + ')') : L('اللون', 'Colour');
    }
    if (/^\s*(size|القياس|المقاس|مقاس|الحجم|حجم)/i.test(t) || (/^\s*(code|كود)/i.test(t) && /قطع|pcs|pieces/i.test(t))) {
      return c ? L('المقاس (كود ' + c + ')', 'Size (Code ' + c + ')') : L('المقاس', 'Size');
    }
    return null;
  }
  function localise(root) {
    root.querySelectorAll('.variant-picker legend, .variant-picker__option-info > span:first-child, .product-card legend').forEach(function (el) {
      if (el.children.length || el.getAttribute('data-da-o')) return;
      el.setAttribute('data-da-o', '1');
      var t = el.textContent.trim(), colon = /:\s*$/.test(t), r = optLabel(t.replace(/:\s*$/, ''));
      if (r) el.textContent = r + (colon ? ':' : '');
    });
    if (!AR) return;
    root.querySelectorAll('.variant-picker legend, .variant-picker__option-info span, .block-swatch span, .line-item p, .line-item span, .product-card legend').forEach(function (el) {
      if (el.children.length || el.getAttribute('data-da-l')) return;
      var t = el.textContent;
      var r = t.split('/').map(function (part) {
        var w = part.trim(), k = ck(w.replace(':', ''));
        if (COL[k]) return part.replace(w, COL[k][0]);
        if (OPT[k]) return part.replace(w.replace(':', '').trim(), OPT[k]);
        return part;
      }).join('/');
      el.setAttribute('data-da-l', '1');
      if (r !== t) el.textContent = r;
    });
    root.querySelectorAll('[data-tooltip]').forEach(function (el) {
      var k = ck(el.getAttribute('data-tooltip'));
      if (COL[k]) el.setAttribute('data-tooltip', COL[k][0]);
    });
  }

  /* 2. Sticky add-to-bag bar: show the same localised name as the product title */
  function stickyTitle(root) {
    var h = root.querySelector('h1.product-info__title'), a = root.querySelector('.product-quick-add .truncate-text');
    if (h && a && a.textContent !== h.textContent.trim()) a.textContent = h.textContent.trim();
  }

  /* 3. Size guide link beside the Size option (moved from the fit row) */
  function sizeLinks(root) {
    root.querySelectorAll('.product-info').forEach(function (pi) {
      var src = pi.querySelector('.da-fit [data-da-sg]');
      if (!src) return;
      pi.querySelectorAll('.variant-picker__option').forEach(function (f) {
        var lg = f.querySelector('legend');
        if (!lg || !/size|مقاس|قياس/i.test(lg.textContent)) return;
        var info = f.querySelector('.variant-picker__option-info');
        if (!info || info.querySelector('.da-sg-inline')) return;
        var b = src.cloneNode(true);
        b.classList.add('da-sg-inline');
        info.appendChild(b);
        src.classList.add('is-moved');
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-da-sg]');
    if (t) {
      e.preventDefault();
      var d = document.getElementById(t.getAttribute('data-da-sg'));
      if (d && d.showModal) { if (d.parentNode !== document.body) document.body.appendChild(d); d.showModal(); }
      return;
    }
    var c = e.target.closest('[data-da-close]');
    if (c) { c.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('da-sg')) { e.target.close(); return; }
    var u = e.target.closest('[data-da-unit]');
    if (u) {
      var dlg = u.closest('dialog'), k = u.getAttribute('data-da-unit');
      dlg.querySelectorAll('[data-da-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
      dlg.querySelectorAll('[data-cm]').forEach(function (td) { td.textContent = td.getAttribute('data-' + k); });
    }
  });

  /* 4. Bundle builder.
     data-cfg = [formId, variants[[id,[options],available]], items[[code,qty,free,option,name,img,sizes[],colours[[name,swatch]],available['Colour|SIZE'],guideId]]] */
  function initBundle(el) {
    el.setAttribute('data-ready', '1');
    var cfg;
    try { cfg = JSON.parse(el.getAttribute('data-cfg')); } catch (err) { return; }
    var formId = cfg[0], variants = cfg[1], items = cfg[2];
    var st = items.map(function (it) {
      if (it[2]) return { size: '-', cols: [], active: 0 }; // free gift: nothing to choose
      var a = [];
      for (var j = 0; j < it[1]; j++) a.push(it[7].length ? null : '-');
      return { size: null, cols: a, active: 0 };
    });
    var box = el.querySelector('.da-bundle__items');
    var errEl = el.querySelector('.da-bundle__error');
    var hid = el.querySelector('.da-bundle__props');

    function sizeOk(it, s) { return it[8].some(function (k) { return k.slice(k.lastIndexOf('|') + 1) === norm(s); }); }
    function colOk(it, c, s) {
      if (s) return it[8].indexOf(c + '|' + norm(s)) > -1;
      return it[8].some(function (k) { return k.indexOf(c + '|') === 0; });
    }
    function nextEmpty(s) { var i = s.cols.indexOf(null); return i === -1 ? s.active : i; }
    function itemDone(i) { return !!items[i][2] || (!!st[i].size && st[i].cols.indexOf(null) === -1); }
    function done() { return items.every(function (it, i) { return itemDone(i); }); }

    function render() {
      box.textContent = '';
      items.forEach(function (it, i) {
        var s = st[i];
        var card = E('div', 'da-bitem' + (it[2] ? ' is-free' : '') + (itemDone(i) ? ' is-done' : ''));
        card.setAttribute('data-i', i);

        var head = E('div', 'da-bitem__head');
        if (it[5]) { var img = E('img', 'da-bitem__img'); img.src = it[5]; img.alt = ''; img.loading = 'lazy'; head.appendChild(img); }
        var info = E('div', 'da-bitem__info');
        var meta = E('p', 'da-bitem__meta', L('كود ', 'Code ') + it[0] + ' · ' + pcs(it[1]));
        if (it[2]) meta.appendChild(E('span', 'da-bitem__gift', L('هدية مجانية', 'Free gift')));
        info.appendChild(meta);
        info.appendChild(E('p', 'da-bitem__name', it[4]));
        head.appendChild(info);
        head.appendChild(E('span', 'da-bitem__tick', '✓'));
        card.appendChild(head);

        if (it[2]) {
          card.appendChild(E('p', 'da-bundle__sub', L('تصلك مجاناً مع العرض، بدون اختيار مقاس أو لون.', 'Comes free with your offer, no size or colour to choose.')));
          box.appendChild(card);
          return;
        }

        /* sizes */
        var sr = E('div', 'da-row');
        var sl = E('div', 'da-row__label');
        sl.appendChild(E('span', '', L('المقاس', 'Size') + (s.size ? ': ' + norm(s.size) : '')));
        if (it[9] && document.getElementById(it[9])) {
          var g = E('button', 'da-sg-link', L('دليل المقاسات', 'Size guide'));
          g.type = 'button'; g.setAttribute('data-da-sg', it[9]); sl.appendChild(g);
        }
        sr.appendChild(sl);
        var sizes = E('div', 'da-sizes');
        it[6].forEach(function (sz) {
          var b = E('button', 'da-size', norm(sz));
          b.type = 'button';
          b.setAttribute('aria-pressed', s.size === sz ? 'true' : 'false');
          if (!sizeOk(it, sz)) { b.disabled = true; b.title = L('نفد هذا المقاس', 'Sold out'); }
          b.addEventListener('click', function () {
            s.size = sz;
            s.cols = s.cols.map(function (c) { return c === '-' || (c && colOk(it, c, sz)) ? c : null; });
            s.active = nextEmpty(s);
            card.classList.remove('is-missing');
            render();
          });
          sizes.appendChild(b);
        });
        sr.appendChild(sizes);
        card.appendChild(sr);

        /* colours: one slot per piece, then the palette */
        if (it[7].length) {
          var cr = E('div', 'da-row');
          var filled = s.cols.filter(Boolean).length;
          var cl = E('div', 'da-row__label');
          cl.appendChild(E('span', '', L('اختاري لون كل قطعة', 'Pick a colour for each piece') + ' (' + filled + '/' + it[1] + ')'));
          cr.appendChild(cl);
          var slots = E('div', 'da-slots');
          s.cols.forEach(function (c, j) {
            var b = E('button', 'da-slot' + (j === s.active ? ' is-active' : '') + (c ? ' is-filled' : ''));
            b.type = 'button';
            if (c) {
              var sw = '';
              it[7].forEach(function (x) { if (x[0] === c) sw = x[1]; });
              b.style.setProperty('--c', colHex(c, sw));
            }
            b.appendChild(E('span', 'da-slot__n', String(j + 1)));
            b.setAttribute('aria-label', L('قطعة ', 'Piece ') + (j + 1) + (c ? ': ' + colLabel(c) : ''));
            b.addEventListener('click', function () { s.active = j; render(); });
            slots.appendChild(b);
          });
          cr.appendChild(slots);
          var pal = E('div', 'da-palette');
          it[7].forEach(function (x) {
            var b = E('button', 'da-sw');
            b.type = 'button';
            var dot = E('span', 'da-sw__dot');
            dot.style.setProperty('--c', colHex(x[0], x[1]));
            b.appendChild(dot);
            b.appendChild(E('span', 'da-sw__name', colLabel(x[0])));
            if (!colOk(it, x[0], s.size)) { b.disabled = true; b.title = L('غير متوفر بهذا المقاس', 'Not available in this size'); }
            b.addEventListener('click', function () {
              s.cols[s.active] = x[0];
              s.active = nextEmpty(s);
              card.classList.remove('is-missing');
              render();
            });
            pal.appendChild(b);
          });
          cr.appendChild(pal);
          if (filled > 0 && filled < it[1]) {
            var same = E('button', 'da-fill', L('نفس اللون لباقي القطع', 'Same colour for the rest'));
            same.type = 'button';
            same.addEventListener('click', function () {
              var c = s.cols[s.active] || s.cols.filter(Boolean).pop();
              s.cols = s.cols.map(function (x) { return x || c; });
              render();
            });
            cr.appendChild(same);
          }
          card.appendChild(cr);
        }
        box.appendChild(card);
      });
      update();
    }

    function update() {
      hid.textContent = '';
      items.forEach(function (it, i) {
        var s = st[i];
        var name = (it[2] ? L('هدية · ', 'Free · ') : '') + L('كود ', 'Code ') + it[0] + ' · ' + pcs(it[1]);
        var val = L('المقاس ', 'Size ') + (s.size ? norm(s.size) : '—');
        if (it[2]) val = L('مجاناً مع العرض', 'Free with the offer');
        else if (it[7].length) val += ' | ' + L('الألوان: ', 'Colours: ') + s.cols.map(function (c) { return c ? colLabel(c) : '—'; }).join(L('، ', ', '));
        var inp = E('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + name + ']';
        inp.value = val;
        inp.setAttribute('form', formId);
        hid.appendChild(inp);
      });
      var paid = [];
      items.forEach(function (it, i) { if (it[3] > 0) paid.push({ o: it[3], s: st[i].size }); });
      if (paid.length && paid.every(function (p) { return p.s; })) {
        var v = null;
        variants.forEach(function (x) {
          if (!v && paid.every(function (p) { return norm(x[1][p.o - 1]) === norm(p.s); })) v = x;
        });
        var f = document.getElementById(formId);
        if (v && f) f.querySelectorAll('input[name=id]').forEach(function (inp) { inp.value = v[0]; inp.disabled = false; });
      }
      if (done()) { errEl.textContent = ''; el.classList.remove('has-error'); el.classList.add('is-complete'); }
      else el.classList.remove('is-complete');
    }

    REG[formId] = function () {
      if (done()) return true;
      errEl.textContent = L('اختاري المقاس واللون لكل القطع قبل الإضافة للسلة', 'Choose a size and colour for every piece before adding to bag');
      el.classList.add('has-error');
      for (var i = 0; i < items.length; i++) {
        if (!itemDone(i)) {
          var card = box.querySelector('[data-i="' + i + '"]');
          if (card) { card.classList.add('is-missing'); card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          break;
        }
      }
      return false;
    };
    render();
  }

  function guard(e, form) {
    // note: form.id would return the <input name="id"> inside the product form, so read the attribute
    var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid || !REG[fid]) return;
    if (!REG[fid]()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }
  window.addEventListener('submit', function (e) { guard(e, e.target); }, true);
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type=submit]');
    if (b) guard(e, b.form);
  }, true);

  /* 5. Language toggle + currency picker in the header (both visible on phones).
     The converter is display-only: Shopify still charges in KWD, which the cart says when another currency is picked.
     Rates: Shopify's public currency file, with fixed Gulf rates as a fallback. */
  var CURS = { KWD: [3, 'KD', 'د.ك'], SAR: [2, 'SAR', 'ر.س'], AED: [2, 'AED', 'د.إ'], QAR: [2, 'QAR', 'ر.ق'], BHD: [3, 'BHD', 'د.ب'], OMR: [3, 'OMR', 'ر.ع'], USD: [2, '$', '$'] };
  var RATE = { KWD: 3.2372, SAR: 0.266667, AED: 0.272294, QAR: 0.274725, BHD: 2.659574, OMR: 2.60078, USD: 1 }; // USD per 1 unit
  function storeGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function storeSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  var cur = storeGet('da_cur');
  if (!CURS[cur]) cur = (window.Shopify && Shopify.country === 'SA') ? 'SAR' : 'KWD';
  function fmtMoney(n, c) {
    var parts = n.toFixed(CURS[c][0]).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (AR ? CURS[c][2] : CURS[c][1]) + (c === 'USD' ? '' : ' ') + parts.join('.');
  }
  function convert(root) {
    root.querySelectorAll('.money').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent;
      if (el.getAttribute('data-da-out') !== t) el.setAttribute('data-da-kwd', t);
      var base = el.getAttribute('data-da-kwd');
      if (cur === 'KWD') {
        if (el.hasAttribute('data-da-out')) { el.textContent = base; el.removeAttribute('data-da-out'); }
        return;
      }
      var mm = toEn(base).replace(/,/g, '').match(/\d+(?:\.\d+)?/); // the label "د.ك" contains a dot, so match the number itself
      if (!mm) return;
      var num = parseFloat(mm[0]);
      var out = (/^\s*-/.test(base) ? '-' : '') + fmtMoney(num * RATE.KWD / RATE[cur], cur);
      if (t !== out) el.textContent = out;
      el.setAttribute('data-da-out', out);
    });
  }
  function curNote() {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (b) {
      var host = b.parentNode, n = host.querySelector('.da-cur-note');
      if (cur === 'KWD') { if (n) n.remove(); return; }
      if (!n) { n = E('p', 'da-cur-note'); host.appendChild(n); }
      var txt = L('الأسعار بـ' + CURS[cur][2] + ' تقريبية، والدفع يتم بالدينار الكويتي.', 'Prices in ' + cur + ' are approximate. You pay in Kuwaiti dinar (KWD) at checkout.');
      if (n.textContent !== txt) n.textContent = txt;
    });
  }
  function locControls() {
    var list = document.querySelector('.header__secondary-nav .header__icon-list');
    if (!list || list.querySelector('.da-loc')) return;
    // the theme's own country/language pickers only show on large screens; ours replace them everywhere
    Array.prototype.forEach.call(list.children, function (li) { if (li.querySelector('x-popover')) li.classList.add('da-hide-loc'); });
    var p = location.pathname, isAr = /^\/ar(\/|$)/.test(p);
    var href = (isAr ? (p.replace(/^\/ar/, '') || '/') : '/ar' + (p === '/' ? '' : p)) + location.search + location.hash;
    var li = E('li', 'da-loc');
    var a = E('a', 'da-lang', isAr ? 'EN' : 'ع');
    a.href = href;
    a.lang = isAr ? 'en' : 'ar';
    a.setAttribute('hreflang', isAr ? 'en' : 'ar');
    a.setAttribute('aria-label', isAr ? 'English' : 'العربية');
    var wrap = E('label', 'da-cur');
    var sel = E('select');
    sel.setAttribute('aria-label', L('العملة', 'Currency'));
    Object.keys(CURS).forEach(function (c) { var o = E('option', '', AR ? CURS[c][2] : c); o.value = c; if (c === cur) o.selected = true; sel.appendChild(o); });
    sel.addEventListener('change', function () { cur = sel.value; storeSet('da_cur', cur); convert(document); curNote(); });
    wrap.appendChild(sel);
    li.appendChild(a);
    li.appendChild(wrap);
    list.insertBefore(li, list.lastElementChild);
  }
  fetch('https://cdn.shopify.com/s/javascripts/currencies.js').then(function (r) { return r.text(); }).then(function (t) {
    Object.keys(RATE).forEach(function (k) { var m = t.match(new RegExp(k + ':([0-9.e-]+)')); if (m && +m[1] > 0) RATE[k] = +m[1]; });
    convert(document);
  }).catch(function () {});

  function run() {
    try {
      locControls();
      convert(document);
      digits(document);
      localise(document);
      curNote();
      sizeLinks(document);
      stickyTitle(document);
      document.querySelectorAll('[data-da-bundle]:not([data-ready])').forEach(initBundle);
    } catch (err) { if (window.console) console.warn('DA', err); }
  }
  var q = 0;
  new MutationObserver(function () {
    if (q) return;
    q = requestAnimationFrame(function () { q = 0; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
